// Third Party Imports
import React from 'react';
import ReactDOM from 'react-dom';
import {routerForBrowser} from 'redux-little-router';
import {polyfill as smoothscrollPolyfill} from 'smoothscroll-polyfill';
// Artifactory
import TrackFocus from '@homeaway/track-focus';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
// Relative Imports
import setupDebugLog from './utils/debugLog';
import {createStoreFromSerializedStore} from './store';
import Root from './Root';
import getRoutes from './routes';
import tripActions from './actions/tripActions';
import edapActions from './actions/edapActions';
import {determineTripDataFromWindow} from './utils/tripData';
import guestSelectorActions from './actions/guestSelectorActions';
import getExperiments from './utils/experimentsHelper';
import {getQueryParams} from './utils/queryStringHelper';

(async function() {
    /* eslint-disable */
    ha.userTiming.measure('responseEnded', 'navigationStart', 'responseEnd');
    // This is the point after all the needed files are downloaded and eval'ed
    ha.userTiming.mark('index.initialize');
    /* eslint-enable */

    // Initial state as set by the server-side render
    const initialState = window.__INITIAL_STATE__;

    // Request state either set by Fastly or the server side render
    const requestState = window.__REQUEST_STATE__;

    const routes = getRoutes(initialState.systemReducer.baseUrlPath);
    const router = routerForBrowser({routes});

    // block on the /experiments request if the visitor is in variant 1 of the caching test
    if (requestState.cacheMode === 1) {
        try {
            initialState.abacusTestsReducer = await getExperiments();
        } catch (e) {
            // do nothing, and just use whatever `initialState.abacusTestsReducer` is currently populated with
        }
    }

    AbacusClientUtils.initialize(initialState.abacusTestsReducer);

    const store = createStoreFromSerializedStore(initialState, router, requestState);
    // Key information for the systemReducer is now filled in during store initialization.
    // So, set this up after the store is ready to roll.
    setupDebugLog(window, store.getState().systemReducer.toJS(), requestState);

    // Expose the public assets path so that Webpack can fetch assets correctly
    __webpack_public_path__ = store.getState().systemReducer.get('webpackPublicPath'); // eslint-disable-line

    // load our trip data from the browser and notify interested consumers via the tripDetailsChanged action
    // (which in turn will fetch the price for the given trip details)
    const tripData = determineTripDataFromWindow(window);
    const {utm_medium, utm_source} = getQueryParams(window.location.search);

    const tripPayload = {
        adults: tripData.adultsCount,
        children: tripData.childrenCount,
        hasPets: tripData.hasPets,
        arriveDateText: tripData.arriveDate,
        departDateText: tripData.departDate,
        isFamilySegment: tripData.isFamilySegment,
        /* eslint-disable  */
        arrivedWithoutDates: !tripData.arriveDate && !tripData.departDate && !(utm_medium === 'display' && utm_source === 'facebook')
        /* eslint-enable */
    };
    store.dispatch(tripActions.tripDetailsChanged(tripPayload, true));

    store.dispatch(guestSelectorActions.guestSelectorDataUpdated({
        adults: tripData.adultsCount,
        children: tripData.childrenCount,
        pets: tripData.hasPets
    }));

    // trigger the 'pageview' now that all trip data has been loaded and the page's ADL has been updated
    store.dispatch(edapActions.triggerEdapEvent('pageview'));

    // set up keyboard focus tracking
    const trackFocus = new TrackFocus();
    trackFocus.bindEvents();

    smoothscrollPolyfill();

    const start = (ListingPageComponent) => {
        const app = (
            <Root store={store} listingPageComponent={ListingPageComponent.default}/>
        );

        ReactDOM.hydrate(app, document.getElementById('root'));
    };

    let importBundle = initialState.systemReducer.get('isMobile')
        ? import('./components/ListingPage/ListingPageMobile')
        : import('./components/ListingPage/ListingPageDesktop');

    importBundle.then(start);
})();
